import type { Navigate } from './types'
import { sendEventCloseConversation } from '../webview/events'

export const closeConversationAndNavigateToMessages = (
  navigate: Navigate,
  search = location.search
) => {
  sendEventCloseConversation()
  navigate(`/messages/${search}`)
}

export const isForbiddenConversationError = (error: unknown): boolean => {
  return (error as import('axios').AxiosError)?.response?.status === 403
}

export const handleForbiddenConversationError = (
  error: unknown,
  onConversationForbidden: () => void
): boolean => {
  if (!isForbiddenConversationError(error)) {
    return false
  }

  onConversationForbidden()
  return true
}